import { render, staticRenderFns } from "./BatchSmsCouponSendPopup.vue?vue&type=template&id=3536cd00&"
import script from "./BatchSmsCouponSendPopup.vue?vue&type=script&lang=js&"
export * from "./BatchSmsCouponSendPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports